import React from 'react';
import BeltIcon from './BeltIcon';
import {BELTS} from '../data/belts';

// Selector de grado en tarjetas. `markedBelt` muestra la etiqueta "Tu grado" en esa cinta.
export default function BeltPicker({value,onChange,markedBelt}) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
      {BELTS.map(belt=> {
        const selected=value===belt.id;
        return (
          <button
            key={belt.id}
            type="button"
            onClick={()=> onChange(belt.id)}
            className={`relative flex flex-col items-center gap-3 p-4 rounded-3xl border transition-all ${
              selected
                ? 'bg-red-600/20 border-red-600 shadow-lg shadow-red-600/10'
                : 'bg-black/20 border-white/10 hover:border-white/30'
            }`}
          >
            {belt.id===markedBelt && (
              <span className="absolute -top-2 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-yellow-400 px-2 py-0.5 text-[9px] font-black uppercase tracking-wider text-zinc-900">
                Tu grado
              </span>
            )}
            <BeltIcon type={belt.id} className="w-12 h-4" />
            <span className={`text-[11px] font-black uppercase tracking-wider text-center [text-shadow:_0_1px_4px_rgba(0,0,0,0.85)] ${selected ? 'text-white' : 'text-white/70'}`}>
              {belt.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
